(function () {
  var DESKTOP_BREAKPOINT = 960;
  var instances = new WeakMap();

  var isDesktop = function () {
    return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
  };

  var getColumnsDesktop = function (section) {
    var columns = parseInt(section.dataset.columnsDesktop, 10);

    if (!columns || columns < 1) {
      columns = parseInt(section.style.getPropertyValue('--custom-related-articles-columns'), 10);
    }

    return columns > 0 ? columns : 4;
  };

  var getEdgeOffset = function (section) {
    var edge = parseFloat(window.getComputedStyle(section).paddingLeft);

    return edge > 0 ? edge : 0;
  };

  var updateEdgeOffset = function (section, swiper) {
    if (!swiper || !swiper.params) {
      return;
    }

    var offset = isDesktop() ? 0 : getEdgeOffset(section);

    if (swiper.params.slidesOffsetAfter !== offset) {
      swiper.params.slidesOffsetAfter = offset;
      swiper.update();
    }
  };

  var updateNavPosition = function (section) {
    if (!isDesktop()) {
      section.style.removeProperty('--custom-related-articles-nav-top');
      section.style.removeProperty('--custom-related-articles-slide-height');
      return;
    }

    var referenceSlide = section.querySelector('.custom-related-articles__slide');

    if (!referenceSlide) {
      return;
    }

    var media = referenceSlide.querySelector('.custom-related-articles__media');
    var mediaHeight = media ? media.offsetHeight : 0;
    var slideHeight = referenceSlide.offsetHeight;
    var navTop = mediaHeight > 0 ? mediaHeight / 2 : slideHeight / 2;

    if (navTop > 0) {
      section.style.setProperty('--custom-related-articles-nav-top', navTop + 'px');
    }

    if (slideHeight > 0) {
      section.style.setProperty('--custom-related-articles-slide-height', slideHeight + 'px');
    }
  };

  var initCarousel = function (section) {
    var swiperEl = section.querySelector('.custom-related-articles__swiper');

    if (!swiperEl || !window.Swiper || swiperEl.swiper) {
      return;
    }

    var columnsDesktop = getColumnsDesktop(section);
    var paginationEl = section.querySelector('.custom-related-articles__pagination');
    var scrollbarEl = section.querySelector('.custom-related-articles__scrollbar');
    var prevEl = section.querySelector('.custom-related-articles__nav--prev');
    var nextEl = section.querySelector('.custom-related-articles__nav--next');

    var updateFraction = function (swiper) {
      if (!paginationEl) {
        return;
      }

      var total = swiper.slides ? swiper.slides.length : 0;
      var current = Math.min((swiper.activeIndex || 0) + 1, total);
      paginationEl.textContent = total ? current + '/' + total : '';
    };

    var updateScrollbarDragSize = function (swiper) {
      if (!scrollbarEl || !swiper || !swiper.params || !swiper.params.scrollbar) {
        return;
      }

      if (!isDesktop()) {
        return;
      }

      var trackWidth = scrollbarEl.offsetWidth;

      if (!trackWidth) {
        return;
      }

      var dragSize = Math.max(1, Math.round(trackWidth * 0.04));

      if (swiper.params.scrollbar.dragSize === dragSize) {
        return;
      }

      swiper.params.scrollbar.dragSize = dragSize;

      if (swiper.scrollbar && typeof swiper.scrollbar.updateSize === 'function') {
        swiper.scrollbar.updateSize();
      }
    };

    var desktopBreakpoint = {
      slidesPerView: columnsDesktop,
      spaceBetween: 24,
    };

    if (scrollbarEl) {
      desktopBreakpoint.scrollbar = {
        enabled: true,
      };
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 1.4,
      spaceBetween: 16,
      speed: 600,
      watchOverflow: true,
      watchSlidesProgress: true,
      simulateTouch: true,
      grabCursor: true,
      preventClicks: true,
      preventClicksPropagation: true,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        960: desktopBreakpoint,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            hide: false,
            snapOnRelease: true,
            enabled: false,
            dragSize: 1,
          }
        : undefined,
      on: {
        init: function () {
          section.querySelectorAll('.custom-related-articles__media img').forEach(function (img) {
            img.setAttribute('draggable', 'false');
          });

          updateEdgeOffset(section, this);
          updateNavPosition(section);
          updateFraction(this);
          updateScrollbarDragSize(this);
        },
        slideChange: function () {
          updateFraction(this);
        },
        slideChangeTransitionEnd: function () {
          updateNavPosition(section);
        },
        resize: function () {
          updateEdgeOffset(section, this);
          updateNavPosition(section);
          updateScrollbarDragSize(this);
        },
        breakpoint: function () {
          updateEdgeOffset(section, this);
          updateNavPosition(section);
          updateScrollbarDragSize(this);
        },
      },
    });

    var onResize = function () {
      updateEdgeOffset(section, swiper);
      updateNavPosition(section);
      updateScrollbarDragSize(swiper);
    };

    var onImagesLoaded = function () {
      updateNavPosition(section);
    };

    window.addEventListener('resize', onResize);

    section.querySelectorAll('.custom-related-articles__media img').forEach(function (img) {
      if (img.complete) {
        return;
      }

      img.addEventListener('load', onImagesLoaded, { once: true });
    });

    instances.set(section, {
      swiper: swiper,
      onResize: onResize,
    });

    updateNavPosition(section);

    return swiper;
  };

  var destroyCarousel = function (section) {
    var instance = instances.get(section);

    if (!instance) {
      return;
    }

    if (instance.onResize) {
      window.removeEventListener('resize', instance.onResize);
    }

    if (instance.swiper) {
      instance.swiper.destroy(true, true);
    }

    instances.delete(section);
    section.style.removeProperty('--custom-related-articles-nav-top');
    section.style.removeProperty('--custom-related-articles-slide-height');
  };

  var initSections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-related-articles]').forEach(function (section) {
      initCarousel(section);
    });
  };

  var destroySections = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-custom-related-articles]').forEach(function (section) {
      destroyCarousel(section);
    });
  };

  var bootstrap = function () {
    initSections();

    if (window.Swiper) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (window.Swiper) {
        window.clearInterval(timer);
        initSections();
      } else if (attempts > 50) {
        window.clearInterval(timer);
      }
    }, 100);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSections(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySections(event.target);
  });
})();
